import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/Pages';
import reportWebVitals from './reportWebVitals';
import { message } from 'antd';
import { redirectLegacyHashRouterPaths } from './core/routing/hash-router-legacy-redirect';
import { ThemeProvider } from './theme/ThemeProvider';

message.config({
  duration: 5,
});

redirectLegacyHashRouterPaths();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
reportWebVitals();
